import { useDispatch, useSelector } from 'react-redux';
import Button from 'components/Basic/Button';
import { toggleManualToolModalState } from 'store/slices/ManualToolModal';
import { selectActiveAction, TOOL_ACTION } from 'store/selectors/toolSelector';
import { RootState } from 'store';

interface FacetListButtonProps {
  onclick?: () => void;
}

export default function FacetListButton({ onclick }: FacetListButtonProps) {
	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(toggleManualToolModalState({ value: true, showAll: true }));
		onclick?.();
	};
	const activeAction = useSelector(selectActiveAction);
	const hideSatelliteOverlay = useSelector((state: RootState) => state.toolNewPostions.data.hideSatelliteOverlay);
	const disableClick = activeAction === TOOL_ACTION.EDIT_CUSTOM_IMAGE || hideSatelliteOverlay;

	return (
		<Button disabled={disableClick} className="open-button edit-facet-btn" onClick={handleClick}>
      Facet List
			<svg width="15" height="15.8" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M11 7H17" stroke="var(--subHeadingColor)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M11 13H17" stroke="var(--subHeadingColor)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M11 2C11 1.44772 11.4477 1 12 1H15.046H16C16.5523 1 17 1.44772 17 2V17C17 17.5523 16.5523 18 
					16 18H15.046H12C11.4477 18 11 17.5523 11 17V2Z" stroke="var(--subHeadingColor)" strokeWidth="1.5" />
				<path d="M1 2C1 1.44772 1.44772 1 2 1H11.7893H16C16.5523 1 17 1.44772 17 2V17C17 17.5523 16.5523 18 16 
					18H11.7893H2C1.44771 18 1 17.5523 1 17V2Z" stroke="var(--subHeadingColor)" strokeWidth="1.5" />
			</svg>
		</Button>
	);
}
